import { Alert, AlertTitle, Box, Stack } from "@mui/material";
import { ContentTitleBar } from "../../../components/ContentTitleBar";

export const LicenseErrorPage = () => {
  return (
    <Stack component="main" height={1}>
      <Box flex={1} p={2}>
        <Alert severity="error" variant="outlined" sx={{ boxShadow: 3 }}>
          <AlertTitle>Invalid License</AlertTitle>
          This server is currently not licensed. Please contact the
          administrator about obtaining a license.
        </Alert>
      </Box>
      <ContentTitleBar label="License Error" />
    </Stack>
  );
};
